import styled from 'styled-components';
import { DefaultPage } from '../../_DefaultPage';

interface IPropsButtonSetPage {
    selected: boolean;
}

export const Container = styled(DefaultPage)``;

export const Content = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const Title = styled.h1`
    @media (max-width: 1100px) {
        margin-bottom: 2rem;
    }
`;

export const ContainerTitleFilter = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;

    div.container-button {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        margin-bottom: 1rem;
    }
`;

export const ContainerFilter = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 1rem;

    @media (max-width: 850px) {
        width: 100%;
    }

    div.big-fields {
        display: flex;
        justify-content: space-between;
        width: 100%;
        gap: 2%;

        @media (max-width: 700px) {
            flex-direction: column;
            gap: 0;
        }
    }

    div.container-name {
        width: 50%;
        display: flex;
        flex-direction: column;

        @media (max-width: 700px) {
            width: 100%;
        }

        span {
            font-size: 1rem;
            margin-bottom: 0.5rem;
        }
    }

    div.created-by {
        width: 40%;
        display: flex;
        flex-direction: column;

        @media (max-width: 700px) {
            width: 100%;
        }

        span {
            font-size: 1rem;
            margin-bottom: 0.5rem;
        }
    }

    div.container-input {
        width: 30%;
        display: flex;
        flex-direction: column;

        @media (max-width: 780px) {
            width: 100%;
        }

        span {
            font-size: 1rem;
            margin-bottom: 0.5rem;
        }
    }

    div.container-select {
        width: 15%;
        display: flex;
        flex-direction: column;

        @media (max-width: 780px) {
            width: 100%;
        }

        span {
            font-size: 1rem;
            margin-bottom: 0.5rem;
        }
    }

    div.container-select-small {
        width: 10%;
        display: flex;
        flex-direction: column;

        @media (max-width: 780px) {
            width: 100%;
        }

        span {
            font-size: 1rem;
            margin-bottom: 0.5rem;
        }
    }
`;

export const ContainerTable = styled.div`
    width: 100%;
    overflow: auto;
    min-height: 10rem;
`;

export const TableCampaigns = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin: 2rem 0;
    min-width: 800px;

    td {
        padding: 1rem;
        border: solid 1px var(--graphite);

        button {
            font-size: 1.2rem;
            padding: 0.5rem 1rem;
            color: var(--white);
            border: none;
            border-radius: 5px;
            margin-right: 1rem;
        }
    }

    thead tr td {
        font-size: 1.4rem;
        font-weight: bold;
        background-color: var(--gray);
        text-align: center;
    }
    tbody tr td {
        font-size: 1.2rem;
        text-align: center;

        :last-child {
            text-align: left;
            div.container-buttons {
                width: 100%;
                display: flex;
            }
            button {
                width: fit-content;
            }
        }
    }
`;

export const AutoCompleteList = styled.ul`
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background-color: var(--white);
    margin: 0;
    padding-left: 0;
    max-height: 15rem;

    li {
        width: 100%;
        list-style: none;
        margin-bottom: solid 1px var(--graphite);
        button {
            width: 100%;
            padding: 5px 10px;
            font-size: 1.2rem;
            color: var(--graphite);
            background-color: transparent;
            border: none;
            text-align: left;
        }
    }
`;

export const ContainerTablePages = styled.div`
    width: 100%;
    margin: 1rem 0;
    display: flex;

    button {
        padding: 0.5rem 1rem;
        background-color: transparent;
        border: none;
        font-size: 1.2rem;
        color: var(--graphite);
    }
`;

export const ButtonSetPage = styled.button<IPropsButtonSetPage>`
    background-color: transparent;
    border: none;
    font-weight: ${props => (props.selected ? 'bold' : 'normal')};
    font-size: ${props => (props.selected ? '2rem' : '1.5rem')};
    margin: 0 15px;
`;

export const StatusFilter = styled.select`
    width: 100%;
    padding: 9px 10px;
    border-radius: 5px;
    border: 1px solid #000;

    @media (max-width: 850px) {
        width: 100%;
    }
`;
